<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="$apollo.loading"
    :items-per-page-options="[10, 25, 50, 100]"
    :search="search"
    v-bind="pagingOptions"
    :hide-default-footer="hideFooter"
  >
    <template v-slot:item.margin="{ item }">
      {{ item.margin | priceLabeler }}
    </template>
    <template v-slot:item.markup="{ item }">
      {{ item.markup | priceLabeler }}
    </template>
    <template v-slot:item.totalCostInBase="{ item }">
      {{ item.totalCostInBase | priceLabeler }}
    </template>
    <template v-slot:item.pricing.totalBuy="{ item }">
      {{ item.pricing.totalBuy | priceLabeler }}
    </template>

    <template v-slot:item.netProfit="{ item }">
      {{ item.netProfit | priceLabeler }}
    </template>
    <template v-slot:item.profit="{ item }">
      {{ item.profit | priceLabeler }}
    </template>

    <template v-slot:item.commission="{ item }">
      {{ item.commission | priceLabeler }}
    </template>
    <template v-slot:item.supplierCommission="{ item }">
      {{ item.supplierCommissionValue | priceLabeler }}
    </template>

    <template v-slot:item.totalPrice="{ item }">
      {{ item.totalPrice | priceLabeler }}
    </template>

    <template v-slot:item.totalSellInBase="{ item }">
      {{ item.totalSellInBase | priceLabeler }}
    </template>
    <template v-slot:item.node.serviceTypeName="{ item }">
      <v-icon>{{ supplierTypeIcon(item.serviceTypeName) }}</v-icon>
    </template>

    <template v-slot:item.serviceTypeName="{ item }">
      <v-icon>{{ supplierTypeIcon(item.serviceTypeName) }}</v-icon>
    </template>
    <template v-slot:item.startDate="{ item }">
      {{ item.startDate | formatDate }}
    </template>

    <template v-slot:item.endDate="{ item }">
      {{ item.endDate | formatDate }}
    </template>

    <template v-slot:item.serviceName="{ item }">
      <v-row v-if="item.isExtra" align="center">
        <v-icon color="yellow darken-2">mdi-star</v-icon>
        {{ item.boardBasis }} ({{ item.serviceName }})
        <from-departure-icon v-if="item.fromDeparture" />
      </v-row>
      <span v-else>
        {{ item.serviceName }}
        <from-departure-icon v-if="item.fromDeparture" />
      </span>
    </template>
    <template v-slot:item.supplierName="{ item }">
      <v-tooltip bottom v-if="item.source && item.source.name != 'GTWEB'">
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="purple" v-bind="attrs" v-on="on" left>
            {{
              `mdi-alpha-${item.source.name
                .replace("GTWEB_", "")
                .charAt(0)
                .toLowerCase()}-circle-outline`
            }}
          </v-icon>
        </template>
        <span>{{ item.source.name.replace("GTWEB_", "") }}</span>
      </v-tooltip>
      {{ item.supplierName }}
    </template>
    <template v-slot:item.isIncluded="{ item }">
      <v-checkbox
        disabled
        class="pa-0 ma-0"
        v-model="item.isIncluded"
        hide-details
      ></v-checkbox>
    </template>
    <template v-slot:item.actions="{ item }">
      <itinerary-details-items-list-actions
        :item="item"
        :serviceType="item.serviceTypeName"
        :itemIsExtra="item.isExtra"
        @showRemarks="onShowRemarks"
        @showItemPricingEditor="onShowItemPricingEditor"
      ></itinerary-details-items-list-actions>
    </template>

    <template v-slot:footer>
      <v-layout justify-space-around> </v-layout>
    </template>
  </v-data-table>
</template>

<script>
import { SupplierTypeIconMixin } from "../../../mixins/SupplierTypeIconMixin";
import { pagingOptions } from "../../../helpers/index";
import ItineraryDetailsItemsListActions from "./ItineraryDetailsItemsListActions.vue";
import FromDepartureIcon from "../shared/FromDepartureIcon.vue";

export default {
  name: "ItineraryDetailsItemsTable",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: () => "",
    },
    hideFooter: {
      type: Boolean,
      defaultd: () => false,
    },
  },

  mixins: [SupplierTypeIconMixin],
  components: {
    ItineraryDetailsItemsListActions,
    FromDepartureIcon,
  },

  data() {
    return {
      pagingOptions,
    };
  },

  methods: {
    onShowRemarks(item) {
      this.$emit("showRemarks", item);
    },
    onShowItemPricingEditor(item) {
      this.$emit("showItemPricingEditor", item);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsItemsTable.vue